import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=9f28dbfa&scoped=true"
import script from "./vHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./vHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=9f28dbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f28dbfa",
  null
  
)

export default component.exports